<template>
  <div>
    <header-view @cCurl="cCurl" ref="headers"></header-view>
    <schedule-view></schedule-view>
    <bulletFrame :pInfo="pInfo" v-if="pInfoShow" @close="pBulletClose"></bulletFrame>
    <scrolling-tip-view @next="next"></scrolling-tip-view>
    <filings-view ref="footerRef"></filings-view>
    <div class="fullpage-container">
      <div class="fullpage-wp" v-fullpage="opts" ref="fullPage">
        <div class="page page1 page-1">
          <div class="page1Warp">
<!--            <video autoplay loop muted src="../../assets/video/pc_bg.mp4"></video>-->
            <video
                class="imgbg"
                loop=""
                id="video29"
                ref="videoElm"
                muted=""
                autoplay=""
                x5-playsinline="true"
                playsinline="true"
                webkit-playsinline="true"
                x-webkit-airplay="allow"
                preload="auto"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                src="../../assets/video/pc_bg.mp4">
            </video>
            <div class="welcomeText fAb">
              <div class="ttv ttvItem" ref="ttvRef">Better Choice</div>
              <div class="ttv1 ttvItem" ref="ttvRef1">Better Partner</div>
            </div>
          </div>
        </div>
        <div class="page page2 page-2" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
          <div class="page2Warp">
            <page2-view></page2-view>
          </div>
        </div>
        <div class="page page-3" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
          <div class="page3Warp">
            <div class="title fAb">Selected Portfolio</div>
            <PortfolioView @openInfo="openBulletOpen" :pList="pList"></PortfolioView>
            <div class="PortfolioMoreBtn fAm" @click="morePortfolio">Learn More</div>
          </div>
        </div>
        <div class="page page-4" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
          <div class="page4Warp" :style="teamDetail?'justify-content:flex-start':''">
            <div class="title fAb">Team</div>
            <TeamDetailView @goDetail="goDetail" v-if="teamDetail"></TeamDetailView>
            <TeamView @goDetail="goDetail" :isHome="true" v-else :teamList="teamList"></TeamView>
            <div v-if="!teamDetail" class="PortfolioMoreBtn fAm" @click="goTeam">Learn More</div>
          </div>
        </div>
        <div class="page page-5" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
          <div class="page5Warp">
            <div class="title fAb">News</div>
            <NewsView></NewsView>
            <div class="PortfolioMoreBtn fAm" @click="goNews">
              <div class="btn fAm">Learn More</div></div>
          </div>
        </div>
        <div class="page page-7" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
          <div class="page5Warp">
            <div class="title fAb">Viewpoint</div>
            <ViewpointView></ViewpointView>
            <div class="pBtnMore">
              <div class="PortfolioMoreBtn fAm" @click="goViewPoint">Learn More</div>
            </div>
          </div>
        </div>
        <div class="page page-6" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
          <div class="page6Warp">
            <div class="title fAb">Contact us</div>
            <div class="contactList">
              <div class="contactItem" v-for="v in contactList" :key="v.id">
                <div class="contactItemTitle fOH">
                  {{ v.title }}
                </div>
                <div class="contactItemDesc fOH">
                  {{ v.desc }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '../../store';
import headerView from '../Common/Header.vue'
import scheduleView from '../Common/pageSchedule.vue'
import scrollingTipView from '../Common/scrollingTip.vue'
import filingsView from '../Common/filings.vue'
import page2View from '../Pages/page2.vue'
import PortfolioView from '../Portfolio/index.vue'
import TeamView from '../Team/index.vue'
import NewsView from '../News/index.vue'
import TeamDetailView from "@/components/Team/Detail/pc.vue";
import ViewpointView from "@/components/Viewpoint/index.vue";
import bulletFrame from "@/components/Portfolio/BulletFrame.vue";
export default {
  components: {
    bulletFrame,
    headerView, scheduleView, scrollingTipView, filingsView,page2View,PortfolioView,TeamView,NewsView,TeamDetailView,ViewpointView},
  props: {},
  data() {
    return {
      pInfo:{},
      pInfoShow:false,
      initS:false,
      headerHeight: 104,
      footerHeight: 48,
      teamDetail:false,
      opts: {
        start: 0,
        dir: 'v',
        duration: 500,
        beforeChange: function (currentSlideEl,currenIndex,nextIndex) {
        },
        afterChange: function (currentSlideEl,currenIndex,nextIndex) {
          // store.dispatch('setPageCurrentIndex',currenIndex)
          store.dispatch('setStoreByKeyData',{key:'setHomeIndex',data:currenIndex})
        }
      },
      reChange:false,
    }
  },
  watch:{
    currenIndex:{
      immediate:true,
      handler(n,o){
        if(n == 0 && n!=o && this.$refs.videoElm){
          this.$refs.videoElm.play()
        }
      }
    },
  },
  computed:{
    fGoHome(){
      return this.$store.getters.fGoHome
    },
    contactList(){
      return this.$store.getters.homeData.contactList
    },
    homeIndex(){
      return this.$store.getters.homeIndex;
    },
    currenIndex(){
      return this.$store.getters.pageCurrentIndex;
    },
    teamList(){
      return this.$store.getters.homeData.teamList
    },
    pList(){
      return this.$store.getters.homeData.homePortfolio
    }
  },
  created() {
    this.$store.dispatch('setStoreByKeyData',{key:'setHomeIndex',data:0})
    setTimeout(r=>{
      // console.log(this.homeIndex)
      // this.$refs.fullPage.$fullpage.moveTo(this.homeIndex)
      this.initS = true
    },100)
    var t = this
    this.$nextTick(r=>{
      t.ttvHideOrShow()
      var index = parseInt(t.fGoHome)
      t.opts.start = index
      t.$store.dispatch('setStoreByKeyData',{key:'setHomeIndex',data:index})
      if(index>0){
        setTimeout(r=>{
          this.$store.dispatch('setStoreByKeyData',{key:'setFGoHome',data:0})
        },200)
      }
    })
  },
  methods: {
    pBulletClose(){
      this.pInfoShow = false
      this.$refs.fullPage.$fullpage.setDisabled(false)
    },
    openBulletOpen(item){
      this.pInfo = item
      this.pInfoShow = true
      this.$refs.fullPage.$fullpage.setDisabled(true)
    },
    goDetail(flg){
      this.teamDetail = flg
      this.$refs.fullPage.$fullpage.setDisabled(flg)
    },
    cCurl(){
      if(this.homeIndex != 0){
        if( this.teamDetail || this.pInfoShow){
          this.teamDetail = false
          this.pInfoShow = false
          this.$refs.fullPage.$fullpage.setDisabled(false)
        }
        this.$refs.fullPage.$fullpage.moveTo(0,true)
      }
    },
    goViewPoint(){
      this.$router.push({name:'Viewpoint'})
    },
    ttvHideOrShow(){
      var t = this
      setTimeout(r=>{
        t.$refs.ttvRef.style.opacity = 0
        t.$refs.ttvRef1.style.opacity = 0
        t.$refs.ttvRef.style.marginTop = '2rem'
        t.$refs.ttvRef1.style.marginTop = '2rem'
        setTimeout(r=>{
          t.ttvHideOrShow()
        },1500)
      },8000)
      setTimeout(r=>{
        t.$refs.ttvRef1.style.opacity = 1
        t.$refs.ttvRef1.style.marginTop = 0
      },2000)
      setTimeout(r=>{
        t.$refs.ttvRef.style.opacity = 1
        t.$refs.ttvRef.style.marginTop = 0
      },500)
    },
    next(){
      this.$refs.fullPage.$fullpage.moveNext()
      this.store.dispatch('setStoreByKeyData',{key:'setHomeIndex',data:this.currenIndex + 1})
    },
    morePortfolio(){
      this.$router.push({name:"Portfolio"})
    },
    goTeam(){
      this.$router.push({name:"Team"})
    },
    goNews(){
      this.$router.push({name:"News"})
    },
  }
}
</script>
<style scoped lang="scss">
.page-6{
  background-image: url("../../assets/image/page6_bg.png");
  .page6Warp{
    height: 100%;
    width: 70%;
    box-sizing: border-box;
    padding: 1rem 0 1rem;
    margin: auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    overflow: hidden;
    overflow-y: auto;
    .contactList{
      color: #fff;
      .contactItem{
        margin-top: 1rem;
        .contactItemTitle{
          font-size: 1.5rem;
        }
        .contactItemDesc{
          font-size: 1.2rem;
          margin-top: .5rem;
        }
      }
    }
    .title{
      text-align: left;
      padding-bottom: 1rem;
      color: #fff;
      font-size: 2.2rem;
      width: 100%;
    }
  }
}
.page-7{
  background-image: url("../../assets/image/page7_bg.png");
  .page5Warp{
    height: 100%;
    width: 70%;
    box-sizing: border-box;
    padding: 1rem 0 1rem;
    margin: auto;
    display: flex;
    align-items: center;
    //justify-content: center;
    flex-direction: column;
    overflow: hidden;
    .pBtnMore{
      padding: 2vh 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .PortfolioMoreBtn{
        display: inline-block;
        padding: .8rem 3rem;
        color: #fff;
        border: .12rem solid #fff;
        font-size: .9rem;
        cursor: pointer;
        margin-top: 2vh;
      }
    }
    .title{
      text-align: left;
      padding: 2rem 0;
      color: #fff;
      font-size: 2.2rem;
      width: 100%;
    }
  }
}
.page-5{
  background-image: url("../../assets/image/page5_bg.png");
  .page5Warp{
    height: 100%;
    width: 70%;
    box-sizing: border-box;
    padding: 1rem 0 1rem;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    overflow: hidden;
    .PortfolioMoreBtn{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .btn{
        display: inline-block;
        padding: .8rem 3rem;
        color: #fff;
        border: .12rem solid #fff;
        font-size: .9rem;
        cursor: pointer;
        margin-top: 2rem;
      }
    }
    .title{
      text-align: left;
      padding-bottom: 2rem;
      color: #fff;
      font-size: 2.2rem;
      width: 100%;
    }
  }
}
.page-4{
  background-image: url("../../assets/image/page4_bg.png");
  .page4Warp{
    height: 100%;
    width: 60%;
    box-sizing: border-box;
    padding: 1rem 0 1rem;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    //overflow: hidden;
    //overflow-y: auto;
    .PortfolioMoreBtn{
      display: inline-block;
      padding: .8rem 3rem;
      color: #fff;
      border: .12rem solid #fff;
      font-size: .9rem;
      cursor: pointer;
      margin-top: 2rem;
    }
    .title{
      text-align: center;
      padding-bottom: 2rem;
      color: #fff;
      font-size: 2.2rem;
    }
  }
}
.page-3{
  background-image: url("../../assets/image/page3_bg.png");
  .page3Warp{
    height: 100%;
    width: 70%;
    box-sizing: border-box;
    padding: 1rem 0 1rem;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    //overflow: hidden;
    //overflow-y: auto;
    .PortfolioMoreBtn{
      display: inline-block;
      padding: .8rem 3rem;
      color: #fff;
      border: .12rem solid #fff;
      font-size: .9rem;
      cursor: pointer;
      margin-top: 2rem;
    }
    .title{
      text-align: center;
      padding-bottom: 2rem;
      color: #fff;
      font-size: 2.2rem;
    }
  }
}
.fullpage-container{
  height: 100vh !important;
}
.page {
  //height: 100vh;
  width: 100%;
  //position: absolute;
  //top: 0;
  //left: 0;
  background-size: 100% 100%;
  //z-index: 10;
  //box-sizing: border-box;
  .page1Warp {
    position: relative;
    video{
      //position: absolute;
      //top: 0;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 0;
      object-fit: cover;
    }
    .welcomeText {
      height: 100vh;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 4.1rem;
      .ttvItem{
        transition: 1.5s;
        opacity: 0;
        margin-top: 2rem;
      }
      .ttv1{
        margin-left: 1.4rem;
      }
    }
  }
}
@keyframes showHideDiv1 {
  0%, 33.3% { opacity: 1; } /* div1 在前2秒显示 */
  33.4%, 66.7% { opacity: 1; } /* div1 在接下来的2秒继续显示 */
  66.8%, 100% { opacity: 0; } /* div1 在接下来的2秒消失 */
}

@keyframes showHideDiv2 {
  0%, 33.3% { opacity: 0; } /* div2 在前2秒隐藏 */
  33.4%, 66.7% { opacity: 1; } /* div2 在接下来的2秒显示 */
  66.8%, 100% { opacity: 0; } /* div2 在接下来的2秒消失 */
}
.page1{
  //background-image: url("../../assets/image/pc_bg.gif");
}
.page2{
  background-image: url("../../assets/image/page2_bg.png");
  .page2Warp{
    height: 100%;
    width: 70%;
    box-sizing: border-box;
    padding: 2rem 0 1rem;
    margin: auto;
  }
}
</style>
